//* Libraries imports
import { Form } from 'react-bootstrap';
import { motion } from 'framer-motion';

//* Animations imports
import { formItemVariants } from '../animations';

type CandidateInfoProps = {
  register: any;
  disabled?: boolean;
};

export function CandidateInfo({ register, disabled = false }: CandidateInfoProps) {
  return (
    <motion.div variants={formItemVariants} custom={2}>
      <Form.Group className="mb-4">
        <Form.Label htmlFor="inscricaoField">Número de Inscrição</Form.Label>
        <Form.Control
          id="inscricaoField"
          type="text"
          readOnly
          className="bg-light"
          title="Número de inscrição do candidato"
          disabled={disabled}
          aria-label="Número de inscrição do candidato"
          {...register("numero_inscricao_candidato")}
        />
      </Form.Group>
    </motion.div>
  );
}
